<template>
  <v-row v-if="partnerPromotions.length" class="ma-0">
    <v-col
      v-for="(partner, index) in partnerPromotions"
      :key="index"
      cols="12"
      :md="isMainPartner(partner) ? 12 : 4"
      class="rounded pa-2"
      :class="isMainPartner(partner) ? '' : 'pt-3'"
    >
      <v-row class="ma-0" justify="center">
        <v-col cols="12" class="pa-0">
          <div class="parentOfImage">
            <v-img
              :aspect-ratio="1.618 / 1"
              :src="partner.PictureUrl"
              gradient="
                to
                top, rgba(0,0,0,1) 0%,
                rgba(0,19,25,0) 46%,
                rgba(0,19,25,0) 86%,
                rgba(0,0,0,0.45702030812324934) 100%"
              class="align-end partnerImage"
            >
              <v-card
                v-if="isMainPartner(partner) && $vuetify.breakpoint.lgAndUp"
                id="informationCard"
                class="primary-font-color rounded-0"
                color="primary"
              >
                <v-col align="center">
                  <v-card-title
                    class="font-weight-bold justify-center word-break"
                    style="font-size: 30px; max-width: 80%"
                  >
                    {{ partner.Name }}
                  </v-card-title>
                  <v-card-text
                    class="partnerDescription homepageDescription pa-0"
                    v-html="partner.Subtitle"
                  />
                  <v-btn
                    color="secondary"
                    large
                    class="secondary-font-color text-capitalize font-weight-bold mt-3"
                    @click="redirect(partner)"
                  >
                    {{ $translate('VIEW') }}
                  </v-btn>
                </v-col>
              </v-card>
            </v-img>
          </div>

          <v-card
            v-if="
              !isMainPartner(partner) ||
              (isMainPartner(partner) && $vuetify.breakpoint.mdAndDown)
            "
            id="informationCard"
            class="primary-font-color rounded-0"
            color="primary"
          >
            <v-col align="center">
              <v-card-title
                class="font-weight-bold justify-center word-break"
                style="font-size: 24px"
              >
                {{ partner.Name }}
              </v-card-title>
              <v-card-text
                class="partnerDescription itemDescription pa-0"
                v-html="partner.Subtitle"
              />
              <v-btn
                color="secondary"
                large
                class="secondary-font-color text-capitalize font-weight-bold mt-3"
                @click="redirect(partner)"
              >
                {{ $translate('VIEW') }}
              </v-btn>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import doRequest from '@/api/dssRequest';
import uiHelpers from '@/shared/ui_helpers';

export default {
  name: 'PartnerInformation',
  mixins: [uiHelpers],
  data() {
    return {
      slideGroup: null,
      partnerPromotions: [],
    };
  },
  mounted() {
    this.getPartnerPromotions();
  },
  methods: {
    getPartnerPromotions() {
      const payload = {
        IncludeAllPartnersInPartnerGroup: false,
        EventTypes: ['PartnerPromotion'],
      };
      doRequest(
        (response) => {
          this.partnerPromotions = [];

          if (response.data.Events != null) {
            Object.entries(response.data.Events).forEach(([key, value]) =>
              this.partnerPromotions.push({ key, ...value })
            );
          }
          // set the partner promotion eventId to call the reviews on
          this.$store.commit(
            'setReviewPartnerEventId',
            this.partnerPromotions[0].EventId
          );
        },
        () => {
          this.error = true;
        },
        'getEvents',
        'LocationsNode_ESE',
        payload,
        'GET'
      );
    },
    isMainPartner(partner) {
      return (
        Number(this.$store.getters['auth/mainPartnerId']) ===
        Number(partner.PartnerId)
      );
    },
    redirect(partner) {
      this.goToPage('EventDetails', {
        event_id: partner.EventId,
      });
    },
  },
};
</script>

<style scoped>
.parentOfImage {
  overflow: hidden;
}
.partnerImage {
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1);
}
.word-break {
  word-break: normal;
}
.partnerDescription {
  display: -webkit-box;
  overflow: hidden !important;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
